module.exports = __webpack_public_path__ + "static/Portfolio07-ceae1c4da8c8ccea65cfe9fc7ea09ea4.jpg";